module.exports = __webpack_public_path__ + "img/tianjin-u+.58b8c687.jpg";